import { NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'ms-bet-radar',
    templateUrl: 'bet-radar.html',
    standalone: true,
    imports: [NgIf],
})
export class BetRadarModalComponent implements OnInit {
    @Input() url: string;
    betRadarUrl: SafeResourceUrl;

    constructor(private sanitizer: DomSanitizer) {}

    ngOnInit(): void {
        this.betRadarUrl = this.transformUrl(this.url);
    }

    private transformUrl(iframeUrl: string): SafeResourceUrl {
        return this.sanitizer.bypassSecurityTrustResourceUrl(iframeUrl);
    }
}
